import {load_products} from './product-catalog'
import {open_collapse} from './../../organisms/filter-collapse'

(function ($) {

	let $form = $('form.product-catalog-filters'),
		delay

	function get_ajax_url(url) {
		let first = true,
			filters = get_active_filters()

		// Add filters if set
		if (filters) {
			for (const [key, value] of Object.entries(filters)) {
				if (value) {
					if (first) {
						first = false
						url += "?"
					} else {
						url += "&"
					}

					url += key + "=" + value
				}
			}
		}

		return url;
	}

	function open_dropdown(event, data) {
		if (window.innerWidth < 768) {
			// Open sidebar instead
			data.open_dropdown = false
			$(document).trigger('open_modal', 'product-catalog-filtration')
			let $filter = $('.sidebar-product-catalog-filtration').find("[data-filter='" + data.filter + "']")
			open_collapse($filter, true)
		}
	}

	$(document).on('open_filter_dropdown', open_dropdown)

	function sync_forms() {
		// Sync checkboxes, radio buttons
		$form.find("input[type='checkbox'], input[type='radio']").change(function () {
			let name = $(this).attr("name")
			let value = $(this).attr("value")
			let is_checked = $(this).is(":checked")
			$form.find("[name='" + name + "'][value='" + value + "']").prop("checked", is_checked)
		})
	}

	sync_forms()

	function get_active_filters() {

		// Get data from form
		var form_data = $form.serializeArray()
		form_data = form_data.filter((item, index, array) =>
				index === array.findIndex((obj) =>
					obj.name === item.name && obj.value === item.value
				)
		)

		// Reset filters object
		let filters = {}

		form_data.forEach(function (item) {
			// Set price_from & price_to only if less/greater than min (default) value
			if (item.name == 'price_from') {
				if (item.value > parseInt($("input[name='price_from']").attr('min'))) {
					filters[item.name] = item.value
				}
			} else if (item.name == 'price_to') {
				if (item.value < parseInt($("input[name='price_to']").attr('max'))) {
					filters[item.name] = item.value
				}
			} else if (filters[item.name]) {
				// Set 2nd and next value
				filters[item.name] += "," + item.value
			} else {
				// Set 1st value
				filters[item.name] = item.value
			}
		})

		return filters
	}

	function set_active_filters() {
		set_active_dropdown_filters()
		set_active_collapse_filters()
	}

	set_active_filters()

	function set_active_dropdown_filters() {

		// Add selected checkboxes filter labels
		let $active_filters = $form.eq(0).find("input[type='checkbox']:checked, input[type='radio']:checked")
		let $active_filters_container = $('.product-catalog-filtration__filtered')
		let active_filters = 0

		// Empty container
		$active_filters_container.empty()


		$active_filters.each(function () {

			if ($(this).val() !== "") {
				active_filters++
				let title = $(this).data('title')

				let active_button = "<button class=\"control-button -active\" type=\"button\">\n" +
					"<span class=\"control-button__title\">" + title + "</span>\n" +
					"<svg width=\"9\" height=\"8\" viewBox=\"0 0 9 8\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n" +
					"    <path d=\"m7.53.53-6 6m-.06-6 6 6\" stroke=\"#1E1E1E\" stroke-width=\"1.5\" stroke-linejoin=\"bevel\"/>\n" +
					"</svg>\n" +
					"</button>"


				let new_label = $(active_button).appendTo($active_filters_container)
				new_label.data('checkbox', $(this))
				// Bind click to remove
				new_label.click(function () {
					let $checkbox = $(this).data('checkbox')
					uncheck_filter($checkbox.attr("name"), $checkbox.attr("value"))
					$form.trigger("change")
				})
			}

		})

		// Add active filter class and "Clear all filters" button
		if (active_filters > 1) {
			let reset_button = $("<button class=\"button -tertiary -m\"><span>Zrušit vše</span></button>").appendTo($active_filters_container)
			reset_button.click(reset_filters)
		}

	}

	function set_active_collapse_filters() {

		$(".filter-collapse").each(function () {

			let $active_filters = $(this).find("input[type='checkbox']:checked, input[type='radio']:checked")

			let filtered = []
			$active_filters.each(function () {
				if ($(this).val() !== "" && $(this).data('title') !== "") {
					filtered.push($(this).data('title'))
				}
			})

			let $filtered_container = $(this).find('.filter-collapse__filtered')

			if (filtered.length > 0) {
				$filtered_container.text(filtered.join(', '))
			} else {
				$filtered_container.empty()
			}

		})

	}

	function uncheck_filter(name, value) {
		$form.find("[name='" + name + "'][value='" + value + "']").prop("checked", false)
	}

	function reset_filters() {

		// Reset checkboxes
		$form.find("input[type='checkbox'], input[type='radio']").prop("checked", false)

		// Reset range
		// var price_min = $price_slider[0].data('slider-min'),
		// 	price_max = $price_slider[0].data('slider-max')
		//
		// $price_slider[0].bootstrapSlider('setValue', [price_min, price_max]);
		// $price_slider[0].trigger('change')

		// Update form
		$form.trigger('change')
	}

	$('[data-reset-filters]').click(reset_filters)

	function form_changed() {

		// Set active filters
		set_active_filters()

		// Clear timeout to prevent spam
		clearTimeout(delay)

		// Wait 0,5sec - prevent request spam caused by fast clicks etc. in filters
		delay = setTimeout(() => {
			let url_base = $(this).attr('action')
			load_products(get_ajax_url(url_base), false)
		}, 500)
	}

	$form.on('change', form_changed)

})(jQuery);